module.exports = __webpack_public_path__ + "img/scene_9.02ae1c7a.jpg";